import microuniversoApi from "app/api/microuniversoApi"
import { Breadcrumb2Container } from "app/components/breadcrumb2/Breadcrumb2Container"
import { ItensOrcamentoContainer } from "app/components/itens-orcamento/ItensOrcamentoContainer"
import { renderizarComponentReact } from "app/components/renderizarOuRemoverComponentReact"
import { ItemOrcamentoController } from "app/controllers/orcamento/itemOrcamentoController"
import { useAppSelector } from "app/redux/hooks"
import { ControllerLegado } from "app/types/ControllerLegado"
import { IItemOrcamento } from "app/types/IItemOrcamento"
import { WindowMU } from "app/types/WindowMU"
import { tratamentoErroPadrao } from "app/use-cases/tratamentoErroPadrao"
import globalMU from "globalMU"
import React, { useEffect, useState } from "react"
import {
    alterarQuantidadeItem as alterarQuantidadeItemUseCase, excluirItens as excluirItensUseCase
} from '../../../use-cases'
import { EditarItemContainer } from "../EditarItemContainer"
import { RegistrarPerdaCotacao } from "../registrar-perda-cotacao/RegistarPerdaCotacao"
import { RegistrarPerdaCotacaoContainer } from "../registrar-perda-cotacao/RegistrarPerdaCotacaoContainer"
import { DadosProdutoSemEstoqueDisponivel, DadosSemEstoqueDisponivel, ProdutoSemEstoqueDisponivel } from "./ProdutoSemEstoqueDisponivel"
declare var window:WindowMU

export type ProdutoSemEstoqueDisponivelContainerProps = {
    identificadorItemSelecionado: number
    dadosCotacaoQuantidadePerdida?: DadosProdutoSemEstoqueDisponivel
    editarIndexItens?: number
    itemOrcamentoController:ControllerLegado
    onVoltar: () => void
    onRegistrarPerdaCotacao: ({
        manterItem,
        dadosProdutoSemEstoqueDisponivel,
        quantidadeProduto
    }:{
        manterItem:boolean
        dadosProdutoSemEstoqueDisponivel: DadosProdutoSemEstoqueDisponivel
        quantidadeProduto:number
    }) => void

    onVoltarParaEdicaoItens: () => void
}

export const ProdutoSemEstoqueDisponivelContainer = (props: ProdutoSemEstoqueDisponivelContainerProps) => {

    const orcamento = useAppSelector((store) => store.orcamento);
    const itemSelecionado = useAppSelector(store => (store.orcamento.ItensOrcamento ?? []).find(i => i.Identificador == props.identificadorItemSelecionado))
    const [estoqueProdutoSemEstoqueDisponivel, setEstoqueProdutoSemEstoqueDisponivel] = useState<DadosSemEstoqueDisponivel>()

    const listaVendaProdutoEstoqueIndisponivel = async () => {
        globalMU.blockUI();
        try {
            setEstoqueProdutoSemEstoqueDisponivel(await microuniversoApi.Produto.vendaProdutoEstoqueIndisponivel(itemSelecionado.Identificador, orcamento.IdentificadorOrcamento));
            globalMU.unblockUI();
        } catch (e) {
            tratamentoErroPadrao(e);

            globalMU.unblockUI();
        }
    };

    const excluirItens = async (itens: IItemOrcamento[]) => {
        globalMU.blockUI()
        try {
            await excluirItensUseCase({ itens })
            globalMU.unblockUI()
            globalMU.showSuccessMessage("Item(ns) excluído(s) com sucesso !")
        } catch (e) {
            tratamentoErroPadrao(e)
            globalMU.unblockUI()
        }
    }

    const onAlterarQuantidadeItem = async () => {
        globalMU.blockUI();
        try {
            console.log(itemSelecionado)
            await alterarQuantidadeItemUseCase({
                identificadorItem: itemSelecionado.Identificador,
                quantidade: itemSelecionado.QuantidadeEstoque,
                quantidadeEstoque: itemSelecionado?.QuantidadeEstoque,
                quantidadeSolicitada: itemSelecionado?.QuantidadeSolicitada,
            });
            globalMU.unblockUI();
        } catch (erro) {
            tratamentoErroPadrao(erro);
            globalMU.unblockUI();
        }
    }

    const confirmar = async (dadosProdutoSemEstoqueDisponivel: DadosProdutoSemEstoqueDisponivel) => {
        if (!dadosProdutoSemEstoqueDisponivel.AjustarQuantidadePedida &&
            !dadosProdutoSemEstoqueDisponivel.LancarDiferencaEmCotacaoPerdida &&
            !dadosProdutoSemEstoqueDisponivel.LancarQuantidadePedidaEmCotacaoPerdida) {
                await excluirItensUseCase({
                    itens: [itemSelecionado]
                })

                window.orcamentoController.showView({
                    region: {
                      name: "itemOrcamentoRegion",
                        selector: "#itens-orcamento-region"
                    },
                    controller: {
                      type: ItemOrcamentoController,
                        args: {
                            model: window.orcamentoController.model,
                            orcamentoController: window.orcamentoController,
                            readOnly: orcamento.SomenteLeitura || orcamento.CodigoDAV !== "" // this.model.get("SomenteLeitura") || this.model.get("CodigoDAV") !== "" // fnx-968
                        }
                    }
                  })

                return
        }

        const deveraRegistrarCotacaoPerdida = dadosProdutoSemEstoqueDisponivel.LancarDiferencaEmCotacaoPerdida || 
            dadosProdutoSemEstoqueDisponivel.LancarQuantidadePedidaEmCotacaoPerdida

        if (deveraRegistrarCotacaoPerdida && orcamento.CodigoCliente == 0) {
            globalMU.showWarnMessage("Cliente não informado. Impossível registrar cotação perdida")
            return
        }

        const quantidadeOriginalSolicitada = itemSelecionado.Quantidade

        if (dadosProdutoSemEstoqueDisponivel.AjustarQuantidadePedida) {
            await alterarQuantidadeItemUseCase({
                identificadorItem: itemSelecionado.Identificador,
                quantidade: itemSelecionado.QuantidadeEstoque,
                quantidadeEstoque: itemSelecionado.QuantidadeEstoque,
                quantidadeSolicitada: quantidadeOriginalSolicitada
            })


        }

        if (deveraRegistrarCotacaoPerdida) {
            const manterItem =  dadosProdutoSemEstoqueDisponivel.LancarDiferencaEmCotacaoPerdida ? true :
                                dadosProdutoSemEstoqueDisponivel.LancarQuantidadePedidaEmCotacaoPerdida ? false : false
            const quantidadeProduto =   dadosProdutoSemEstoqueDisponivel.LancarDiferencaEmCotacaoPerdida ? 
                                        quantidadeOriginalSolicitada - itemSelecionado.QuantidadeEstoque :
                                        quantidadeOriginalSolicitada

            props.onRegistrarPerdaCotacao({
                manterItem, dadosProdutoSemEstoqueDisponivel, quantidadeProduto
            })                               

            
        } else {
            props.onVoltarParaEdicaoItens()
        }
    }

    

    useEffect(() => {
        listaVendaProdutoEstoqueIndisponivel();
    }, [])

    return (
        <>
            <Breadcrumb2Container
                exibirBotaoLimpar={false}
                exibirBotaoVoltar={true}
                id="ProdutoSemEstoqueDisponivelBreadcrumb"
                onBotaoVoltarClicado={() =>{
                    props.onVoltar()

                }}
                passos={["Itens", "Editar itens", "Produto Sem Estoque Disponível"]}
                onPassoSelecionado={passo => {
                    if (passo == "Editar itens") {
                        props.onVoltarParaEdicaoItens()
                        
                    }

                    if (passo == "Itens") {
                        window.orcamentoController.showView({
                            region: {
                              name: "itemOrcamentoRegion",
                                selector: "#itens-orcamento-region"
                            },
                            controller: {
                              type: ItemOrcamentoController,
                                args: {
                                    model: window.orcamentoController.model,
                                    orcamentoController: window.orcamentoController,
                                    readOnly: orcamento.SomenteLeitura || orcamento.CodigoDAV !== "" // this.model.get("SomenteLeitura") || this.model.get("CodigoDAV") !== "" // fnx-968
                                }
                            }
                        })

                        
                    }
                }}
            />

            <br />

            {itemSelecionado != null && <ProdutoSemEstoqueDisponivel codigoFilial={itemSelecionado?.CodigoFilialRetirada ? itemSelecionado?.CodigoFilialRetirada : orcamento?.CodigoFilialOrcamento}
                dadosSemEstoqueDisponivel={estoqueProdutoSemEstoqueDisponivel}
                item={itemSelecionado}
                onExcluirItens={(item) => {
                    excluirItens([item])
                    renderizarComponentReact(
                        <ItensOrcamentoContainer />,
                        "conteudo-pagina",
                        true
                    )
                }}
                onAlterarQuantidadeItem={() => onAlterarQuantidadeItem()}
                onConfirmar={confirmar}
            />}
        </>

    )
}
